// extracted by mini-css-extract-plugin
module.exports = {"title":"headerAnnounce_title__3EsDq","falshing":"headerAnnounce_falshing__3pk5g","heart":"headerAnnounce_heart__2_1-8"};